"use strict";

import "./VehicleList.css";
import React from "react";
import classnames from "classnames";

import dispatcher from "./../../dispatcher";
import sessionStore from "./../../store/session";
import dataTypeStore from "./../../store/dataTypes";
import serviceStore from "./../../store/services";
import vehicleStore from "./../../store/vehicles";
import vehicleFilterExpressionStore from "./../../store/vehicleFilterExpression";
import selectedVehicleStore from "./../../store/selectedVehicle";
import vehicleStateStore from "./../../store/vehicleStates";
import pinnedVehicleStore from "./../../store/pinnedVehicles";
import displayedDetailsStore from "./../../store/displayedDetails";

import shouldComponentUpdate from "vwa/shouldComponentUpdate";

import Button from "vwa/components/Button";
import List from "vwa/components/List";
import Filter from "./Filter";
import Summary from "./Summary";

import filterGroups from "vwa/utils/filterGroups";
import filterVehicles from "./filterVehicles";
import {getResolvedVehicleState, getMovingStateOfVehicle} from "./../../utils/vehicle";

export default class VehicleList extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
		this.setStoreListeners();
	}
	
	initState() {
		this.state = {
			vehicles:			filterGroups(vehicleStore.getAll()),
			filterExpression:	vehicleFilterExpressionStore.get(),
			selectedVehicle:	selectedVehicleStore.get(),
			vehicleStates:		vehicleStateStore.getAll(),
			pinnedVehicles:		pinnedVehicleStore.getAll()
		};
	}
	
	setStoreListeners() {
		vehicleStore.on('change', vehicles => this.setState({vehicles: filterGroups(vehicles)}));
		vehicleFilterExpressionStore.on('change', filterExpression => this.setState({filterExpression}));
		selectedVehicleStore.on('change', selectedVehicle => this.setState({selectedVehicle}));
		vehicleStateStore.on('change', vehicleStates => this.setState({vehicleStates}));
		pinnedVehicleStore.on('change', pinnedVehicles => this.setState({pinnedVehicles}));
	}
	
	getState(vehicleId) {
		if (!this.state.vehicleStates)
			return null;
		const vehicleState = this.state.vehicleStates.find(s => s.carrier == vehicleId);
		return vehicleState || null;
	}
	
	// SIDE_EFFECT: referenciálisan ugyanaz a state és a nextState
	/* shouldComponentUpdate(...nexts){
		return shouldComponentUpdate(this, ...nexts);
	} */
	
	getStatefulAndListedVehicles() {
		const filteredVehicles = this.getFilteredVehicles();
		
		const filteredAndStatefulVehicles = filteredVehicles ? filteredVehicles.filter(v => this.getState(v._id)) : null;
		
		if (this.state.selectedVehicle) {
			if (this.getState(this.state.selectedVehicle))
				return [vehicleStore.get(this.state.selectedVehicle)];
			else
				return [];
		}
		else if (filteredVehicles) {
			return filteredAndStatefulVehicles;
		}
		else if (this.state.vehicles) {
			return this.state.vehicles.filter(v => this.getState(v._id));
		}
		else
			return [];
	}
	
	getListedVehiclesPinStatus() {
		const currentListedVehicles = this.getStatefulAndListedVehicles().map(v => v._id);
		const pinnedCurrentListedVehicleIds = currentListedVehicles.filter(id =>
			this.state.pinnedVehicles && this.state.pinnedVehicles.indexOf(id) > -1
		);
		
		if (pinnedCurrentListedVehicleIds.length == 0)
			return 0;
		else if (pinnedCurrentListedVehicleIds.length == currentListedVehicles.length)
			return 2;
		else if (pinnedCurrentListedVehicleIds.length < currentListedVehicles.length && pinnedCurrentListedVehicleIds.length > 0)
			return 1;
		else return 0;
	}
	
	handleFilterChange(expression) {
		dispatcher.dispatch('filterVehicles', expression);
	}
	
	handlePinChange(value) {
		const vehicleIds = this.getStatefulAndListedVehicles().map(v => v._id);
		dispatcher.dispatch('pinVehicles', vehicleIds, value);
	}
	
	switchVehicleDetails(vehicleId) {
		const displayedDetails = displayedDetailsStore.get();
		if (!displayedDetails)
			dispatcher.dispatch("openDetails", "VehicleDetails", vehicleId);
		else if (displayedDetails.id == vehicleId)
			dispatcher.dispatch("closeDetails", "VehicleDetails", vehicleId);
		else
			dispatcher.dispatch("openDetails", "VehicleDetails", vehicleId);
	}
	
	getFilteredVehicles() {
		return filterVehicles(
			dataTypeStore,
			this.state.vehicles,
			this.state.vehicleStates,
			this.state.filterExpression
		);
	}
	
	renderFilter() {
		return (
			<Filter
				filterExpression={this.state.filterExpression}
				pinStatus={this.getListedVehiclesPinStatus()}
				onFilter={this.handleFilterChange.bind(this)}
				onPinChange={this.handlePinChange.bind(this)}
			/>
		);
	}
	
	renderList(vehicles, expanded) {
		expanded = expanded || false;
		return (
			<List>
				{vehicles ? vehicles.map(vehicle =>
					<Summary
						expanded={expanded}
						key={vehicle._id}
						vehicle={vehicle}
						onFocus={() => dispatcher.dispatch('focusVehicle', vehicle._id)}
						pinned={this.state.pinnedVehicles ? (this.state.pinnedVehicles.find(e => e==vehicle._id) ?  true : false) : false}
						onPinChange={value => dispatcher.dispatch('pinVehicles', [vehicle._id], value)}
						onSwitchVehicleDetails={ () => this.switchVehicleDetails(vehicle._id) }
					/>
				) : ""}
			</List>
		);
	}
	
	renderFullList() {
		return (
			<div className="ListContainer">
				{this.renderList(this.state.vehicles)}
			</div>
		);
	}
	
	renderFilteredList() {
		
		const className = classnames("ListContainer", {"Hidden":  !this.getFilteredVehicles()});
		
		return (
			<div className={className}>
				<header>
					<Button icon="arrow-left" onClick={_ =>
						dispatcher.dispatch('filterVehicles', null)
					}/>
				</header>
				{this.renderList(this.getFilteredVehicles())}
			</div>
		);
	}
	
	renderSelectedList() {
		const className = classnames("ListContainer", {"Hidden": !this.state.selectedVehicle});
		const vehicle = this.state.selectedVehicle ? this.state.vehicles.find(v => v._id == this.state.selectedVehicle) : null;
		return (
			<div className={className}>
				<header>
					<Button icon="arrow-left" onClick={_ =>
						dispatcher.dispatch('selectVehicle', null)
					}/>
				</header>
				{this.renderList(vehicle ? [vehicle] : null, true)}
			</div>
		);
	}
	
	render() {
		
		const filter = this.renderFilter();
		const fullList = this.renderFullList();
		const filteredList = this.renderFilteredList();
		const selectedList = this.renderSelectedList();
		
		return (
			<div className="VehicleList">
				{filter}
				<div id="body">
					{fullList}
					{filteredList}
					{selectedList}
				</div>
			</div>
		);
	}
	
}


// WEBPACK FOOTER //
// ./src/view/VehicleList/VehicleList.jsx